import { INameId } from '@modeso/types__aumico-lib-core-be';
export class ObjectUtils {
    public static getValueFromObject(object: object, key: string): string {
        if (object) {
            return object[key] || '';
        } else {
            return '';
        }
    }
    public static isKeyExists(object: object, key: string): boolean {
        return object && object[key];
    }

    public static getSelectedItemFromDropDownOptions(
        object: object,
        key: string,
        dropDownOptions: INameId[],
    ): INameId | '' {
        const selectedDropDownOption = this.isKeyExists(object, key.toLocaleLowerCase())
            ? dropDownOptions.find(
                  (dropDownOption) => dropDownOption.id.toLocaleLowerCase() === object[key].toLocaleLowerCase(),
              )
            : '';
        return selectedDropDownOption;
    }
}
